import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class TodoDetail extends Component {
    render() {
        // 날짜 변환
        let writeDate = ''

        const newDate = new Date(this.props.item.createdAt)
        const newYear = newDate.getFullYear()

        let newMonth = newDate.getMonth() + 1
        if (newMonth < 10) {
            newMonth = '0' + newMonth
        }
        let newDay = newDate.getDate()
        if (newDay < 10) {
            newDay = '0' + newDay
        }

        writeDate = `${newYear}.${newMonth}.${newDay}`

        let dueDate = ''
        let dDay = ''
        if (this.props.item.dueDate) {
            const newDate = new Date(this.props.item.dueDate)
            const newYear = newDate.getFullYear()

            let newMonth = newDate.getMonth() + 1
            if (newMonth < 10) {
                newMonth = '0' + newMonth
            }
            let newDay = newDate.getDate()
            if (newDay < 10) {
                newDay = '0' + newDay
            }

            newDate.setHours(12)
            newDate.setMinutes(0)
            newDate.setSeconds(0)
            newDate.setMilliseconds(0)
            const dueDateSec = newDate.getTime()

            const nowTime = new Date()

            nowTime.setHours(12)
            nowTime.setMinutes(0)
            nowTime.setSeconds(0)
            nowTime.setMilliseconds(0)
            const nowDateSec = nowTime.getTime()

            dueDate = `${newYear}.${newMonth}.${newDay}`

            let gap = dueDateSec - nowDateSec
            gap = Math.floor(gap / (1000 * 60 * 60 * 24))

            if (gap > 0) {
                dDay = `D-${gap}`
            } else if (gap === 0) {
                dDay = 'D-Day'
            } else if (gap < 0) {
                dDay = '마감'
            }
        } else {
            dueDate = '지정안됨'
            dDay = ''
        }

        return (
            <Link to={`/todo/${this.props.item._id}`}>
                <ul className="item">
                    <li className="title">
                        <p className="title_text">{this.props.item.title}</p>
                        <p className="reply_length">[{this.props.item.comments.length}]</p>
                    </li>
                    <li className="name pc_v_impo">{this.props.item.writer.name}</li>

                    {this.props.item.status === 'CLOSE' ? (
                        <li className="date">
                            {writeDate}
                            <span className="d_day d_day_complete mobile_v">완료</span>
                        </li>
                    ) : (
                        <li className="date">
                            {writeDate}
                            {dDay !== '' && <span className={'d_day mobile_v'}>{dDay}</span>}
                        </li>
                    )}
                    {this.props.item.status === 'CLOSE' ? (
                        <li className="d_day d_day_complete pc_v_impo">완료</li>
                    ) : dDay !== '' ? (
                        <li className={'d_day pc_v_impo'}> {dDay}</li>
                    ) : (
                        <></>
                    )}
                </ul>
            </Link>
        )
    }
}

export default TodoDetail



// WEBPACK FOOTER //
// ./Src/Components/Todo/TodoItem.js